import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
const Page = lazy(
  () => import("@/features/sub-orders/paidout-detail/page.client"),
);
export const Route = createFileRoute(
  "/_authed/staff/sub/paidout-detail",
)({
  component: () => (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  ),
});
